import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const TextDivider = ({
  text,
  variant,
  className: classNameProp,
}) => {
  const className = clsx(
    'co-text-divider',
    {
      'small': variant == 'small',
      'medium': variant == 'medium',
      'large': variant == 'large',
    },
    classNameProp,
  )
  return (
    <div className={className}>
      {text}
    </div>
  )
};

TextDivider.defaultProps = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['small', 'medium', 'large']),
}

export default TextDivider;
